module.exports = __webpack_public_path__ + "img/mind_background_12.95695929.png";